import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-star",
  "use": "icon-star-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-star\"><path class=\"st2\" d=\"M7.1 0c.1.1.1.3.2.4.2.5.4 1.1.7 1.6.4.8.8 1.7 1.1 2.5 0 .1.1.1.1.1l3.7.6c.4.1.7.1 1.1.2 0 0 0 .1-.1.1L11.4 8l-.9.9-.1.1c.2 1.1.3 2.2.5 3.3.1.6.2 1.1.2 1.7v.1s-.1 0-.1-.1l-1.7-1c-.8-.5-1.6-.9-2.4-1.4h-.1c-.8.4-1.6.9-2.4 1.3-.6.3-1.2.6-1.7.9h-.1l.1-.5.6-3.6c0-.3.1-.5.1-.8v-.2c-.7-.7-1.3-1.4-2-2.1L0 5.3c.1 0 .3 0 .4-.1 1.4-.2 2.9-.4 4.3-.6.1 0 .2-.1.2-.1.3-.7.7-1.4 1-2.1L7.1 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol